<template>
  <div class="gold_box">
    <h3 class="activeR">我的钱包</h3>
    <div class="pay_money">
      <!-- <b class="fz"
        >德乙币：<b class="activeR">0 德乙币 </b
        ><b class="activeH2">(*10德乙币 = 1元)</b></b
      > -->
      <b class="fz"
        >可提金额：<b class="activeR">0.00 元 </b
        ><b class="activeH2">(*其中冻结：0.00元)</b></b
      >
      <div>
        <!-- <el-button size="mini" type="warning"
          ><router-link :to="{ name: 'goldpay' }">充值</router-link></el-button
        > -->
        <el-button size="mini" type="primary"
          ><router-link :to="{ name: 'goldpay' }">提款</router-link></el-button
        >
      </div>
    </div>
    <el-divider></el-divider>
    <b>交易记录：</b>
    <div class="deal">
      <b class="activeH2">您还没有购买过德乙币，来一发呗!</b>
      <img src="../../../assets/Currency_Isometric.png" />
    </div>

    <!-- <el-divider></el-divider>
    <p>您还没有购买过虎扑币，来一发呗。</p> -->
  </div>
</template>
<style scoped lang="less">
.gold_box {
  h3 {
    margin-bottom: 10px;
    font-weight: 600;
  }
  b {
    color: #000;
    font-size: 14px !important;
  }
  .pay_money {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
.deal {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  img {
    width: 300px;
  }
}
</style>
